<template>
    <div class="container-fluid" @click="$emit('go-to-event', 'SelectionScreenId')">
        <div class="row d-flex justify-content-between align-items-center screen-height">
            <div class="col text-center">
                <img src="../../assets/bg-insieme-logo.svg" class="img-fluid mb-5 w-50 cursor-pointer" alt="">
                <h1 class="thin-text mb-5 fs-3">Perché la vita è fatta di progetti da realizzare.</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartScreen',
        emits: ['go-to-event'],
    }
</script>